import React, { useContext } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import MissingToolMappingsContext from '@totem/components/salesOrders/missingToolMappings/MissingToolMappingsContext';

const styles = {
  searchContainer: {
    marginBottom: '0.5rem',
  },
  search: {
    width: '240px',
  },
};

const MissingToolMappingsFilters = () => {
  const { searchText, setSearchText } = useContext(MissingToolMappingsContext);

  return (
    <div style={styles.searchContainer}>
      <Input
        prefix={<SearchOutlined />}
        placeholder="Search sales order..."
        style={styles.search}
        value={searchText}
        onChange={(evt) => setSearchText(evt.target.value)}
        allowClear
      />
    </div>
  );
};

export default MissingToolMappingsFilters;
